import Vue from 'vue';
import NavHead from './NavHead';
import NavFoot from './NavFoot';
import Sider from './Sider';
import ModifyPwd from './ModifyPwd';
import Payroll from './Payroll';
import PayrollOne from './PayrollOne';
import MemberPayroll from './MemberPayroll';
import BulletionBoard from './BulletinBoard';
import Rule from './AgtPolicy/Rule';
import Introduction from './AgtPolicy/Introdution';
import Settlement from './AgtPolicy/Settlement';
import Agreement from './TeacherPolicy/Agreement';
import Contract from './TeacherPolicy/Contract';
import ModifyProfile from './ModifyInfo/ModifyProfile';
import VideoIntro from './ModifyInfo/VideoIntro';
import MoreInfo from './ModifyInfo/MoreInfo';
import Wangeditor from './WangEditor';

const GlobalComponents = () => {
  Vue.component('nav-head',NavHead);
  Vue.component('nav-foot',NavFoot);
  Vue.component('sider',Sider);
  Vue.component('modify-pwd',ModifyPwd);
  Vue.component('payroll',Payroll);
  Vue.component('member-payroll',MemberPayroll);
  Vue.component('bulletion-board',BulletionBoard);
  Vue.component('rule',Rule);
  Vue.component('introduction',Introduction);
  Vue.component('settlement',Settlement);
  Vue.component('agreement',Agreement);
  Vue.component('contract',Contract);
  Vue.component('payroll-one',PayrollOne);
  Vue.component('modify-profile',ModifyProfile);
  Vue.component('more-info',MoreInfo);
  Vue.component('video-intro',VideoIntro);
  Vue.component('wangeditor',Wangeditor);
};
export default GlobalComponents;



// WEBPACK FOOTER //
// ./src/global-components/index.js